import { render, staticRenderFns } from "./SimpleCrud.vue?vue&type=template&id=355b04de&scoped=true"
import script from "./SimpleCrud.vue?vue&type=script&lang=js"
export * from "./SimpleCrud.vue?vue&type=script&lang=js"
import style0 from "./SimpleCrud.vue?vue&type=style&index=0&id=355b04de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b04de",
  null
  
)

export default component.exports